import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route } from '@angular/router';
import { AppTab } from '../app-template/models/app-tab.model';
import { AdminPageDefinition } from '../sm-base/models/admin-page-definition.model';
import { FeatureModule } from '../sm-base/models/feature.module';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { UtilsModule } from '../utils/utils.module';
import { DevMainComponent } from './components/dev-main/dev-main.component';
import { DevRoutingModule } from './dev-routing.module';



@NgModule({
  declarations: [
    DevMainComponent
  ],
  imports: [
    CommonModule,
    SmBaseModule,
    UtilsModule
  ]
})
export class DevModule implements FeatureModule {

    constructor(private featureModuleService: FeatureModuleService) {
        featureModuleService.register(this);
    }

    getId(): string {
        return "DevModule";
    }
    
    registerSidebar(_: AppTab[]): void {
    }

    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("dev", () => DevRoutingModule);
    }

    async beforeAppStart(): Promise<void> {
    }

    getAdminPages(): AdminPageDefinition[] {
        return [];
    }
}